<script setup>
import {computed} from "vue";

const props = defineProps({
  value: {
    type: Object,
    required: true
  }
})

const variant = computed(() => {
  if (props.value.voided)
    return 'warning'

  switch (props.value.track_status) {
    case 'D':
      return 'success'

    case 'X':
    case 'E':
      return 'danger'

    case 'I':
      return 'primary'

    default:
      return 'secondary'
  }
})
</script>

<template>
  <b-alert :variant="variant" show class="d-flex">
    <div class="flex-fill my-auto">
      <li v-if="value.voided"><b>Label Voided</b></li>
      <li v-if="value.return_shipment"><b>Return Label</b></li>
      <li>Shipped on {{ value.ship_date | date }} via
        {{ value.shipping && value.shipping.carrier && value.shipping.carrier.description }}
      </li>
      <template v-if="value.track_status === 'D'">
        <li><b>Delivered</b> on {{ value.track_deliver_date | date}}</li>
        <li v-if="value.track_sign_by">Signed for by {{ value.track_sign_by }}</li>
      </template>
      <template v-else-if="value.track_status === 'I'">
        <li><b>In Transit</b> as of {{ value.track_last_update_date | date}}</li>
        <li v-if="!!value.track_est_deliver_date">Estimated delivery on {{ value.track_est_deliver_date | date}}</li>
      </template>
      <li v-else-if="value.track_status === 'C'"><b>Label Created</b> as of {{ value.track_last_update_date | date }}</li>
      <template v-else-if="['X','E'].includes(value.track_status)">
        <li>Carrier tracking Error/Exception</li>
        <li v-if="value.track_error">{{ value.track_error}}</li>
      </template>
    </div>
    <slot/>
  </b-alert>
</template>

<style scoped>

</style>